import {IHumanTimeConfig} from "../../../../../components/shared/human-time/HumanTimeConfigBuilder";

export default interface IAggregationOptions {
    aggregations?: {
        [uuid: string]: {
            field: string,
            type: string,
            title: string,
            format?: string,
            humanTimeFormat?: IHumanTimeConfig
            placement?: string[]
            color?: string,
            background?: string,
        }
    }
}

export const VIEW_AGGREGATION_PLACEMENT = {
    TOP: 'top',
    MIDDLE: 'middle',
    BOTTOM: 'bottom'
}

export const VIEW_AGGREGATION_PLACEMENT_LIST = [
    {value: VIEW_AGGREGATION_PLACEMENT.TOP, labelFallback: 'Úplně nahoře', label: 'configuration.view.unit.aggregation.placement.top'},
    {value: VIEW_AGGREGATION_PLACEMENT.MIDDLE, labelFallback: 'Pod akcemi', label: 'configuration.view.unit.aggregation.placement.middle'},
    {value: VIEW_AGGREGATION_PLACEMENT.BOTTOM, labelFallback: 'Dole', label: 'configuration.view.unit.aggregation.placement.bottom'}
]